import { useTheme } from './use-theme';
export var useThemeEval = function useThemeEval() {
  var t = useTheme();
  return function (func) {
    return func({
      theme: t
    });
  };
};